<template>
  <div class="auth-card">
    <div class="auth-title">
      <h2>{{ title }}</h2>
      <p v-if="subtitle">{{ subtitle }}</p>
    </div>
    <div class="auth-body">
      <slot />
    </div>
  </div>
</template>

<script setup>
defineProps({
  title: { type: String, required: true },
  subtitle: { type: String, default: '' }
})
</script>

<style scoped>
.auth-card {
  width: 420px;            
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: 18px;
  box-shadow: var(--shadow);
  padding: 22px;
}

.auth-title h2 {
  margin: 0 0 6px;
  font-size: 22px;
}

.auth-title p {
  margin: 0 0 18px;
  color: var(--muted);
  font-size: 14px;
}

.auth-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>